import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { OmsServiceService } from '../../services/oms-service.service';
import { ConstantsService } from '../../services/constants.service';
import { FormGroup, FormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-order-cancel-model',
  templateUrl: './order-cancel-model.component.html',
  styleUrls: ['./order-cancel-model.component.scss']
})
export class OrderCancelModelComponent implements OnInit {


  orderCancelForm: FormGroup;

  orderCancelTypes: [];
  orderCancelSubTypes: [];
  isFormValid: Boolean=false;
  msg :string ="";
  isButtonEnable :Boolean =true;
  isSuccessMsg :Boolean =false;
  isFailureMsg :Boolean =false;
  isOrderCancel: boolean = false;
  isEscalationOrderCancel: boolean = false;
  per100:any;
  per80:any;
  per60:any;
  per40:any;
  per20:any;
  @Input() channel_code ;
  constructor(public modal: NgbActiveModal,
    private omsServiceService: OmsServiceService,
    private constantsService: ConstantsService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private spinnerService:NgxSpinnerService,
    private toastr: ToastrService
  ) {
    this.orderCancelForm = new FormGroup({

      reasonType: new FormControl(),
      subReasonType: new FormControl(),
      reason: new FormControl(),
      percentage: new FormControl(),
      totalAmount: new FormControl()
    });

  }

  @Input() orderObj;
  @Input() isCancelOrderType;
  order_id: string = "";
  ngOnInit(): void {
    this.isButtonEnable  =true;
    //console.log(this.orderObj);
    this.order_id = this.orderObj.order.patientinfo.order_id;
    this.getAllCancelationReasons();

     if(this.isCancelOrderType == 1){
       this.isOrderCancel=true
      }else if(this.isCancelOrderType == 2){
        this.isEscalationOrderCancel=true
      }

      this.per100=((100 / 100) * parseInt(this.orderObj.payment_info.gross_amount)).toFixed(2)
      this.per80=((80 / 100) * parseInt(this.orderObj.payment_info.gross_amount)).toFixed(2)
      this.per60=((60 / 100) * parseInt(this.orderObj.payment_info.gross_amount)).toFixed(2)
      this.per40=((40 / 100) * parseInt(this.orderObj.payment_info.gross_amount)).toFixed(2)
      this.per20=((20 / 100) * parseInt(this.orderObj.payment_info.gross_amount)).toFixed(2)

    this.orderCancelForm.patchValue({
      totalAmount: this.orderObj.payment_info.gross_amount
    })
  }


  orderCancel(orderCancelFormData) {

   if( this.isCancelOrderType == 1)
  {
    let orderCancelRequest = {};
    orderCancelRequest["order_id"] = [this.order_id];
    orderCancelRequest["reason"] = orderCancelFormData.controls.reason.value;
    orderCancelRequest["reason_text"] = "";
    orderCancelRequest["comment"] = "";
    orderCancelRequest["scheduled_date"] = "";
    orderCancelRequest["reasonType"] = "";
    orderCancelRequest["actionById"] = window.localStorage.getItem('actionById');
    orderCancelRequest["actionByName"] = window.localStorage.getItem('actionByName');
    orderCancelRequest["source"] = "1";
    orderCancelRequest["role"] = "";
    orderCancelRequest["channelCode"] = this.constantsService.CHANNEL_CODE;
    orderCancelRequest["categoryId"] = orderCancelFormData.controls.reasonType.value;
 
    orderCancelRequest["subCategoryId"] = orderCancelFormData.controls.subReasonType.value;
    orderCancelRequest["action"] = "OMS/api/operation.php/v1/orderCancel";
    orderCancelRequest["type"] = "post";
    this.spinnerService.show();
    this.omsServiceService.orderCancel(orderCancelRequest).subscribe(
      (res) => {
        if (res["status"] == 1) {
           this.isSuccessMsg =true;
          this.msg=res["msg"][0]["msg"];
        } else {
         this.isFailureMsg =true;
         this.msg=res["msg"][0]["msg"];
        //  this.spinnerService.hide();
        }
        this.isButtonEnable  =false;
        this.spinnerService.hide();
      }
    )
  }else if( this.isCancelOrderType == 2 ){
    let orderCancelRequest = {};
    let val=this.orderCancelForm.get('percentage').value
      if(val == null){
        orderCancelRequest["refund_amount"] = 0
      }else if(val == 100){
        orderCancelRequest["refund_amount"] = this.per100
      }else if(val == 80){
        orderCancelRequest["refund_amount"] = this.per80
      }else if(val == 60){
        orderCancelRequest["refund_amount"] = this.per60
      }else if(val == 40){
        orderCancelRequest["refund_amount"] = this.per40
      }else if(val == 20){
        orderCancelRequest["refund_amount"] = this.per20
      }
    orderCancelRequest["order_ids"] = [this.order_id];
    orderCancelRequest["reason"] = orderCancelFormData.controls.reason.value;
    orderCancelRequest["isInternalCall"] = 1;
    orderCancelRequest["comment"] = "";
    // orderCancelRequest["refund_amount"] = this.orderObj.payment_info.gross_amount;
    orderCancelRequest["actionById"] = window.localStorage.getItem('actionById');
    orderCancelRequest["actionByName"] = window.localStorage.getItem('actionByName');
    orderCancelRequest["action"] = "OMS/api/operation.php/v1/orders/cancel/manually";
    orderCancelRequest["type"] = "post";
    this.spinnerService.show();
    this.omsServiceService.escalationOrderCancel(orderCancelRequest).subscribe(
      (res) => {
        if (res["status"] == 1) {
           this.isSuccessMsg =true;
          this.msg=res["msg"][0]["msg"];
        } else {
         this.isFailureMsg =true;
         this.msg=res["msg"][0]["msg"];
        }
        this.isButtonEnable  =false;
        this.spinnerService.hide();
      }
    )
  }
  
  // if(orderCancelFormData.controls.reasonType.value !="" && orderCancelFormData.controls.reasonType.value !=null && orderCancelFormData.controls.reasonType.value !=undefined)
  // {
  //   if(orderCancelFormData.controls.subReasonType.value !=""  && orderCancelFormData.controls.subReasonType.value !=null && orderCancelFormData.controls.subReasonType.value !=undefined)
  //   {
  //     this.isFormValid =true;
      
  //   }else{
  //     this.toastr.error("please select sub reason type");

  //   }
  // }else{
  //   this.toastr.error("please select reason type");
  // }
  // if(this.isFormValid)
  // {


  //   //console.log(orderCancelFormData);
  //   let orderCancelRequest = {};
  //   orderCancelRequest["order_id"] = [this.order_id];
  //   orderCancelRequest["reason"] = orderCancelFormData.controls.reason.value;
  //   orderCancelRequest["reason_text"] = "";
  //   orderCancelRequest["comment"] = "";
  //   orderCancelRequest["scheduled_date"] = "";
  //   orderCancelRequest["reasonType"] = "";
  //   orderCancelRequest["actionById"] = window.localStorage.getItem('actionById');;
  //   orderCancelRequest["actionByName"] = window.localStorage.getItem('actionByName');;
  //   orderCancelRequest["source"] = "1";
  //   orderCancelRequest["role"] = "";
  //   orderCancelRequest["channelCode"] = this.constantsService.CHANNEL_CODE;
  //   //orderCancelRequest["channelCode"] =this.channel_code;
  //   orderCancelRequest["categoryId"] = orderCancelFormData.controls.reasonType.value;

  //   orderCancelRequest["subCategoryId"] = orderCancelFormData.controls.subReasonType.value;
  //   this.spinnerService.show();
  //   this.omsServiceService.orderCancel(orderCancelRequest).subscribe(
  //     (res) => {
  //       //console.log(res);
  //       if (res["status"] == 1) {

  //          this.isSuccessMsg =true;
  //         //alert(res["msg"][0]["msg"]);
  //         //this.msg=res["msg"][0].chiss_response[0].message;
  //         this.msg=res["msg"][0]["msg"];
  //        // this.modal.close();
  //         //this.orderDetailsPage(this.order_id);
  //         //this._router.navigate(['/orders'], { queryParams: { session: localStorage.getItem("sessionId") } });

  //       } else {
  //        // alert(res["msg"]);
  //        // this.modal.close();
  //        this.isFailureMsg =true;
  //        //this.msg=res["msg"];
  //        this.msg=res["msg"][0]["msg"];
  //        //console.log(this.msg);

  //       }
  //       this.isButtonEnable  =false;
  //       this.spinnerService.hide();
  //     }
  //   )
  // }
    

  }

  orderDetailsPage(orderId) {

    this._router.navigate(["order-details", orderId]);
  }

  getAllCancelationReasons() {
    let orderCancelReasonRequest = {};
    orderCancelReasonRequest["source"] = "CP";
    orderCancelReasonRequest["entity"] = "cancellation";
    orderCancelReasonRequest["tenantCode"] = this.orderObj.tenantCode;
    orderCancelReasonRequest["orgCode"] = this.orderObj.orgCode;
    orderCancelReasonRequest["method"] = "fetchservice/getCancellationRescheduleTypes";
    orderCancelReasonRequest["type"] = "post";


    //getCancelTypes
    this.omsServiceService.getCancelTypes(orderCancelReasonRequest).subscribe(
      (res) => {

        if (res["status"] == "success") {
          this.orderCancelTypes = res["data"];

        }


      }
    )
  }

  getSubType(type) {

    this.getAllCancelationSubReasons(type);

  }

  getAllCancelationSubReasons(obj) {
    let orderCancelReasonRequest = {};
    orderCancelReasonRequest["source"] = "CP";
    orderCancelReasonRequest["entity"] = "cancellation";
    orderCancelReasonRequest["tenantCode"] = this.orderObj.tenantCode;
    orderCancelReasonRequest["orgCode"] = this.orderObj.orgCode;
    orderCancelReasonRequest["typeId"] = obj;
    orderCancelReasonRequest["method"] = "fetchservice/getCancellationRescheduleTypes";
    orderCancelReasonRequest["type"] = "post";


    this.omsServiceService.getCancelTypes(orderCancelReasonRequest).subscribe(
      (res) => {

        if (res["status"] == "success") {
          this.orderCancelSubTypes = res["data"].subTypes;
          //console.log(this.orderCancelTypes);
        }


      }
    )
  }
  
  modelClose()
  {

    this.modal.close();
    // this._router.navigate(['/orders'], { queryParams: { session: localStorage.getItem("sessionId") } });
  }

  close()
  {

    this.modal.close();
    
  }
}
